<template>
  <hl-Modal
    v-if="show"
    :title="`Nedgradering av abonnement for ${tenantName}`"
    class="text-center"
    iconClass="budicon-business-area text-primary"
    dismisable
    @close="$emit('update:show', false)"
  >
    <p>
      Ved å nedgradere mister du utleieforsikring og gratis juridisk bistand, og du vil være mindre trygg ved et
      eventuelt mislighold eller skade på boligen.
    </p>

    <div class="mt-5">
      <hl-Button class="mx-2" :disabled="downgrading" :loading="downgrading" @click="$emit('click:downgrade')">
        Nedgrader
      </hl-Button>
      <hl-Button class="mx-2" variant="secondary" outline @click="$emit('update:show', false)"> Avbryt </hl-Button>
    </div>
  </hl-Modal>
</template>

<script>
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';

export default {
  name: 'UpgradeSubscriptionModal',

  components: {
    'hl-Modal': Modal,
    'hl-Button': Button,
  },

  props: {
    show: Boolean,
    tenantName: String,
    newPrice: Number,
    downgrading: Boolean,
  },
};
</script>
